module.exports = __webpack_public_path__ + "img/10886_L.598b99b2.png";